export const 轉呼 = [null, null, null, ...'開合開合開開合開合開合開合開合開合開合開合開開開合開合開合開合開合開開開開合開合'] as const;

export const 轉名稱列表 = [
  '內轉第一',
  '內轉第二',
  '外轉第三',
  '內轉第四',
  '內轉第五',
  '內轉第六',
  '內轉第七',
  '內轉第八',
  '內轉第九',
  '內轉第十',
  '內轉第十一',
  '內轉第十二',
  '內轉第十三',
  '外轉第十四',
  '外轉第十五',
  '外轉第十六',
  '外轉第十七',
  '外轉第十八',
  '外轉第十九',
  '外轉第二十',
  '外轉第二十一',
  '外轉第二十二',
  '外轉第二十三',
  '外轉第二十四',
  '外轉第二十五',
  '外轉第二十六',
  '內轉第二十七',
  '內轉第二十八',
  '內轉第二十九',
  '外轉第三十',
  '內轉第三十一',
  '內轉第三十二',
  '外轉第三十三',
  '外轉第三十四',
  '外轉第三十五',
  '外轉第三十六',
  '內轉第三十七',
  '內轉第三十八',
  '外轉第三十九',
  '外轉第四十',
  '外轉第四十一',
  '外轉第四十二',
  '外轉第四十三',
] as const;

export const 母位置名稱 = [
  null,
  '脣音第一位',
  '脣音第二位',
  '脣音第三位',
  '脣音第四位',
  '舌音第一位',
  '舌音第二位',
  '舌音第三位',
  '舌音第四位',
  '牙音第一位',
  '牙音第二位',
  '牙音第三位',
  '牙音第四位',
  '齒音第一位',
  '齒音第二位',
  '齒音第三位',
  '齒音第四位',
  '齒音第五位',
  '喉音第一位',
  '喉音第二位',
  '喉音第三位',
  '喉音第四位',
  '舌齒音第一位',
  '舌齒音第二位',
] as const;

export const 母2idx = [...'幫滂並明端透定泥知徹澄孃見溪羣疑精清從心邪章昌船書常莊初崇生俟影曉匣云以來日'] as const;

export const 母idx2右位 = [
  1, 2, 3, 4, 5, 6, 7, 8, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 13, 14, 15, 16, 17, 13, 14, 15, 16, 17, 18, 19, 20, 21, 21, 22, 23,
] as const;
